const ApiAccessAdmin = () =>
  <>
    You must be logged in with administrator privileges to manage access.
  </>

export default ApiAccessAdmin
